import { getWebConfig } from "../../api";
import { detectPlatform, timeFormat } from "../../util/commonUtil";
import { tipToast } from "../../util/toastUtils";
import { sendCustomEvent } from "../../util/slog";
let webConfig = {
    "download_url": {
        "mac_arm": "",
        "mac_intel": "",
        "windows": ""
    },
    "current_version_win": {
        "version_name": "",
        "version_value": 0,
        "update_time": 0
    },
    "current_version_mac": {
        "version_name": "",
        "version_value": 0,
        "update_time": 0
    },
    "qywx": {
        "kefu": ""
    }
}

const download = (type, site) => {
    const platform = detectPlatform()
    console.log("platform", platform);

    if (platform.includes('win') || platform.includes('mac')) {
        if (type === 'win') {
            console.log('win')
            if (!webConfig.download_url.windows) return tipToast('暂无该系统安装包，敬请期待！')
            window.location.href = webConfig.download_url.windows
            sendCustomEvent('download_click', `pack-win site-${site}`)
            //下载界面无需跳
            // if (window.location.href.includes('/download') && (!downloadType || downloadType.includes('win'))) return
            // setTimeout(() => {
            //     window.location.href = __PAGE_DOMAIN__ + `download?type=${type}`
            // },500)
            return
        }

        if (type === 'mac_m') {
            console.log('mac_m')
            if (!webConfig.download_url.mac_arm) return tipToast('暂无该系统安装包，敬请期待！')
            window.location.href = webConfig.download_url.mac_arm
            sendCustomEvent('download_click', `pack-mac_m site-${site}`)
            //下载界面无需跳
            // if (window.location.href.includes('/download') && downloadType.includes('mac')) return
            // setTimeout(() => {
            //     window.location.href = __PAGE_DOMAIN__ + `download?type=${type}`
            // },500)
            return
        }

        if (type === 'mac_intel') {
            console.log('mac_intel')
            if (!webConfig.download_url.mac_intel) return tipToast('暂无该系统安装包，敬请期待！')
            window.location.href = webConfig.download_url.mac_intel
            sendCustomEvent('download_click', `pack-mac_intel site-${site}`)
            //下载界面无需跳
            // if (window.location.href.includes('/download') && downloadType.includes('mac')) return
            // setTimeout(() => {
            //     window.location.href = __PAGE_DOMAIN__ + `download?type=${type}`
            // },500)
            return
        }

    } else {
        $('#contactUsDialog').css('display', 'flex')
    }
}

$(function () {
    //发送访问日志
    sendCustomEvent('view', window.location.href)
    let platform = detectPlatform()

    getWebConfig().then(res => {
        if (res.code === 1) {
            webConfig = res.data
            // if (webConfig.qywx.kefu) {
            //     $('#kefuQr').attr('src', webConfig.qywx.kefu);
            //     $('#contactQr').attr('src', webConfig.qywx.kefu);
            //     $('#kefuLoading').hide()
            //     $('#kefuQr').show()
            // }
            $('#winVersion').text(`版本号：V${webConfig.current_version_win.version_name !== '' ? webConfig.current_version_win.version_name : '0.0.0'} | 更新时间：${timeFormat(new Date(webConfig.current_version_win.update_time * 1000), 'yyyy-MM-dd')}`)
            $('#macVersion').text(`版本号：V${webConfig.current_version_mac.version_name !== '' ? webConfig.current_version_mac.version_name : '0.0.0'} | 更新时间：${timeFormat(new Date(webConfig.current_version_mac.update_time * 1000), 'yyyy-MM-dd')}`)
            // $('#macVersionBottom').text(`版本号：V${webConfig.current_version_mac.version_name !== '' ? webConfig.current_version_mac.version_name : '0.0.0'} | 更新时间：${timeFormat(new Date(webConfig.current_version_mac.update_time * 1000),'yyyy-MM-dd')}`)
            $('.page_one_info').css('opacity', '1')
        }
    })

    $('#downloadWin').on('click', () => {
        download('win', 'home')
    })

    // $('#downloadMac').on('click', () => {
    //     download('mac', 'home')
    // })

    $('#downloadMacM').on('click', () => {
        download('mac_m', 'home')
    })

    $('#downloadMacIntel').on('click', () => {
        download('mac_intel', 'home')
    })

    // id=downloadMac 悬停展示 id=downloadMenu
    const $downloadMac = $('#downloadMac')
    const $downloadMenu = $('#downloadMenu')
    let macHoverHideTimer = null

    if ($downloadMac.length && $downloadMenu.length) {
        const placeMenu = () => {
            const offset = $downloadMac.offset()
            const height = $downloadMac.outerHeight() || 0
            const width = ($downloadMac.outerWidth() || 0) + 48
            $downloadMenu.css({
                display: 'block',
                position: 'absolute',
                top: offset.top + height + 24,
                left: offset.left - 24,
                width: width,
            })
        }

        const showMenu = () => {
            clearTimeout(macHoverHideTimer)
            placeMenu()
        }

        const hideMenu = () => {
            macHoverHideTimer = setTimeout(() => {
                $downloadMenu.css('display', 'none')
            }, 100)
        }

        $downloadMac.on('mouseenter', showMenu)
        $downloadMac.on('mouseleave', hideMenu)
        $downloadMenu.on('mouseenter', showMenu)
        $downloadMenu.on('mouseleave', hideMenu)
    }
})
